import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// Styles
import './index.css';
import '@cyhnkckali/vue3-color-picker/dist/style.css';
import 'vue3-colorpicker/style.css';
import 'primeicons/primeicons.css';
import 'vue3-toastify/dist/index.css';
import '@programic/vue3-tooltip/dist/index.css';
import 'vue-awesome-paginate/dist/style.css';

// Plugins
import VueAwesomePaginate from 'vue-awesome-paginate';
import { AnimateInViewComponent } from '@neeravp/vue-3-animate-in-view';
import Vue3Toastify, { type ToastContainerOptions, toast } from 'vue3-toastify';
import Vue3Marquee from 'vue3-marquee';
import { MotionPlugin } from '@vueuse/motion';
import Tooltip from '@programic/vue3-tooltip';

// Tooltip default options
const tooltipOptions = {
  position: 'bottom-left',
  type: 'light',
};

// Toast default options
const toastOptions: ToastContainerOptions = {
  autoClose: 3000,
};

// Remove loader helper
function hideLoader() {
  const loader = document.getElementById('app-loader');
  if (loader) loader.remove();
}

// Load reCAPTCHA
function loadRecaptcha(siteKey: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof grecaptcha !== 'undefined') {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA'));
    document.head.appendChild(script);
  });
}

const app = createApp(App);

const RECAPTCHA_SITE_KEY = '6LcUcS4sAAAAAK34Qh7FiDMquC4fH4h15lJh2XIr';

// 🚀 Load everything first, then mount app
loadRecaptcha(RECAPTCHA_SITE_KEY)
  .then(() => {
    app
      .component('animate-in-view', AnimateInViewComponent)
      .use(Vue3Marquee)
      .use(MotionPlugin)
      .use(Vue3Toastify, toast, toastOptions)
      .use(Tooltip, tooltipOptions)
      .use(store)
      .use(router)
      .use(VueAwesomePaginate)
      .mount('#app');

    hideLoader(); // ✅ REMOVE LOADING 
  })
  .catch((err) => {
    hideLoader();
    console.error(err);
    alert('Failed to load app. Please refresh the page.');
  });
